import { render, staticRenderFns } from "./SwipeFloor.vue?vue&type=template&id=0133f0a5&scoped=true&"
import script from "./SwipeFloor.vue?vue&type=script&lang=js&"
export * from "./SwipeFloor.vue?vue&type=script&lang=js&"
import style0 from "./SwipeFloor.vue?vue&type=style&index=0&id=0133f0a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0133f0a5",
  null
  
)

export default component.exports